<template>
  <div style="padding: 80px 0px 20px">
    <div class="flex_head">
      <div class="userInfo" @click="toAddLabel">
        <van-row>
          <van-col span="18">
            <div class="label" v-show="labelList.length">
              <span v-for="(item, index) in checkedLabelList" :key="index">{{
                item
              }}</span>
            </div>
          </van-col>
          <van-col
            span="6"
            style="color: #eee; text-align: right; min-width: 71px"
          >
            我的标签
            <van-icon name="arrow" />
          </van-col>
        </van-row>
      </div>
      <div v-if="list.length" class="tips">
        根据您当前的标签，为您推荐了{{ list.length }}条政策
      </div>
    </div>
    <div class="p15" v-if="list.length">
      <div
        @click="toDtl(item.id)"
        class="list"
        v-for="(item, index) in list"
        :key="index"
      >
        <div class="label">
          人才政策 > {{ item.classificationList | filterClassificationList }}
        </div>
        <div class="title">{{ item.name }}</div>
      </div>
    </div>
    <div v-else>
      <div class="empty">
        <img src="../images/noData.png" alt="" />
        <div class="tips">
          <div>暂无智能推荐</div>
          <div>请选择其他标签试试</div>
        </div>
      </div>
      <div class="p15" style="border-top: 10px solid #f0f2f5">
        <div class="hotTitle">热门推荐</div>
        <div
          @click="toDtl(item.id)"
          class="list"
          v-for="(item, index) in hotList"
          :key="index"
        >
          <div class="label">
            人才政策 > {{ item.classificationList | filterClassificationList }}
          </div>
          <div class="title">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checkedLabelList: [],
      list: [],
      hotList: [],
      tipsList: "",
    };
  },
  filters: {
    filterClassificationList(list) {
      let resultTips = [];
      if (list.length) {
        list.forEach((item) => {
          resultTips.push(item.classification);
        });
        return resultTips.join(" > ");
      }
    },
  },
  methods: {
    labelList(data) {
      let searchList = [];
      data.forEach((item) => {
        if (item.tagOptionValue) {
          searchList.push(item.tagOptionValue);
        }
      });
      this.checkedLabelList = [...searchList.slice(0, 5)];
    },
    // 匹配列表
    getList(parame) {
      this.$http.home.getMatchList(parame).then((res) => {
        if (res.data) {
          this.list = res.data;
        }
      });
    },
    // 热门列表
    getPolicyList(parame) {
      this.$http.home.getPolicyList(parame).then((res) => {
        if (res.data) {
          this.hotList = res.data.pageInfo.content;
        }
      });
    },
    toAddLabel() {
      this.$router.push("/addlabel");
    },
    // 查看详情
    toDtl(id) {
      this.$router.push(`/policyDetail/${id}`);
    },
  },
  created() {
    let data = localStorage.getItem("H_rct_data");
    if (data) {
      let data2 = JSON.parse(data),
        data3 = [];
      data2.forEach((item, index) => {
        if (item.tagOptionId && typeof item.tagOptionId == "string") {
          item.tagOptionId.split(",").forEach((it, idx) => {
            data3.push({
              tagId: item.tagId,
              tagOptionId: +it,
              tagOptionValue: item.tagOptionValue.split(",")[idx],
            });
          });
        } else {
          data3.push(item);
        }
      });
      this.labelList(data3);
      this.getList(data3);
    } else {
      this.getPolicyList({
        currentPage: 1,
        pageSize: 4,
        queryDesc: 1, // 1正 2倒序
        queryOrderBy: 1,
        queryName: "",
        classificationIds: null,
      });
    }
  },
};
</script>
<style lang="less" scoped>
.flex_head {
  position: fixed;
  top: 20px;
  left: 15px;
  right: 15px;
  // background: #fff;
}
.userInfo {
  font-size: 14px;
  margin-top: 10px;
  .label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    span {
      border-radius: 2px;
      background: #fee8bd;
      padding: 1px 5px;
      color: #f2a200;
      margin-right: 5px;
      display: inline-block;
    }
  }
}
.tips {
  font-size: 14px;
  color: #6d90e2;
  line-height: 20px;
  margin-top: 15px;
  padding-bottom: 5px;
}
.list {
  font-size: 14px;
  font-weight: 400;
  color: #515359;
  line-height: 22px;
  .title {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; //行数
    -webkit-box-orient: vertical;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
  }
  .label {
    font-size: 12px;
    color: #797d7b;
    line-height: 17px;
    padding-top: 10px;
  }
}
.empty {
  width: 100%;
  text-align: center;
  img {
    width: 117px;
    height: 110px;
  }
  .tips div:nth-child(1) {
    font-size: 16px;
    font-weight: 600;
    color: #515359;
    line-height: 22px;
    margin-top: 20px;
    margin-bottom: 4px;
  }
  .tips div:nth-child(2) {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.5);
    line-height: 20px;
    margin-bottom: 30px;
  }
}
.hotTitle {
  font-size: 16px;
  font-weight: 600;
  color: #515359;
  line-height: 22px;
  margin-bottom: 6px;
}
</style>



// WEBPACK FOOTER //
// src/view/autoMatch.vue